import { LEGAL_NAVIGATION, LINKS, NAVIGATION_MOBILE } from '@utils/constants';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useState } from 'react';

import * as styles from './Navigation.module.css';

import CategoryListing from '@components/Listing/CategoryListing';
import Arrow from '@components/SVG/Arrow';
import ArrowLeft from '@components/SVG/ArrowLeft';
import Grid from '@components/SVG/Grid';
import ProductSearch from '@components/Search/ProductSearch';

const MobileNavigation = ({
	showMobileMenu,
	className = '',
}: {
	showMobileMenu: boolean;
	className?: string;
}): JSX.Element => {
	const [showSubMenu, setShowSubMenu] = useState(false);

	return (
		<div
			className={cx(styles.modal, {
				[styles.active]: showMobileMenu,
				[className]: !!className,
			})}>
			<div className={cx(styles.layout, 'container')}>
				<ProductSearch type="compact" theme="dark" />
				{NAVIGATION_MOBILE && (
					<nav>
						<ul className={styles.list}>
							{NAVIGATION_MOBILE.map(
								({ label, to, onClick, icon }, key) => {
									let iconToUse;

									switch (icon) {
										case 'grid':
											iconToUse = (
												<Grid
													className={styles.iconGrid}
												/>
											);
											break;
										case 'arrow':
											iconToUse = (
												<Arrow
													className={styles.iconArrow}
												/>
											);
										default:
											break;
									}

									return (
										<li className={styles.item} key={key}>
											{onClick ? (
												<button
													className={styles.link}
													onClick={() =>
														setShowSubMenu(true)
													}>
													{label}
													{iconToUse}
												</button>
											) : (
												<Link
													to={to}
													className={styles.link}>
													{label}
													{iconToUse}
												</Link>
											)}
										</li>
									);
								}
							)}
						</ul>
					</nav>
				)}

				{LEGAL_NAVIGATION && (
					<nav>
						<ul className={cx(styles.list, styles.space)}>
							{LEGAL_NAVIGATION.map(({ label, to }, key) => (
								<li key={key}>
									<Link
										to={to}
										className={cx(
											styles.link,
											styles.small
										)}>
										{label}
									</Link>
								</li>
							))}
						</ul>
					</nav>
				)}

				<div
					className={cx(styles.modal, styles.subModal, {
						[styles.active]: showSubMenu,
					})}>
					<div className={cx(styles.layout, 'container')}>
						<nav>
							<ul className={styles.list}>
								<li className={styles.item}>
									<button
										className={cx(
											styles.link,
											styles.compact
										)}
										onClick={() => setShowSubMenu(false)}>
										<ArrowLeft
											className={styles.iconArrow}
										/>
										Products
									</button>
								</li>

								<li className={cx(styles.item, styles.altItem)}>
									<Link
										className={cx(
											styles.link,
											styles.altLink
										)}
										to={LINKS.PRODUCTS}>
										Show all product categories
										<Arrow className={styles.iconArrow} />
									</Link>
								</li>
							</ul>
						</nav>

						<div className={styles.listing}>
							<CategoryListing theme="dark" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MobileNavigation;
